import React, { Component } from 'react';
import Plot from 'react-plotly.js';
import PropTypes from 'prop-types';

class ForecastGraph extends Component {
  render() {
    const { data, title } = this.props;
    const {
      a0AllInCountry,
      b0AllInCountry,
      c0AllInCountry,
      d0AllInCountry,
      totPop,
    } = data;

    return (
      <Plot
        data={[
          {
            x: [3, 2, 4, 3],
            y: [2, 3, 3, 4],
            text: [
              `Urmm: ${Math.floor(a0AllInCountry)}`,
              `Durrit: ${Math.floor(b0AllInCountry)}`,
              `Capalla: ${Math.floor(c0AllInCountry)}`,
              `Ottania: ${Math.floor(d0AllInCountry)}`,
            ],
            textfont: {
              family: 'Oswald, sans-serif',
              size: 18,
              color: '#232d4b',
            },
            mode: 'markers+text',
            marker: {
              color: '#E5E7EB',
              line: {
                color: '#232d4b',
                width: 1,
              },
              opacity: [
                0.5 + a0AllInCountry / totPop,
                0.5 + b0AllInCountry / totPop,
                0.5 + c0AllInCountry / totPop,
                0.5 + d0AllInCountry / totPop,
              ],
              size: 100,
            },
          },
        ]}
        layout={{
          title: title,
          height: 300,
          width: 350,
          margin: {
            l: 0,
            r: 0,
            b: 0,
            t: 30,
            pad: 4,
          },
          xaxis: {
            autorange: true,
            showgrid: false,
            zeroline: false,
            showline: false,
            autotick: true,
            ticks: '',
            showticklabels: false,
          },
          yaxis: {
            autorange: true,
            showgrid: false,
            zeroline: false,
            showline: false,
            autotick: true,
            ticks: '',
            showticklabels: false,
          },
          autosize: true,
          showlegend: false,
          hovermode: false,
        }}
      />
    );
  }
}

ForecastGraph.propTypes = {
  data: PropTypes.object.isRequired,
  title: PropTypes.string,
};

export default ForecastGraph;
